var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vuestic-icon-vue",
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 55.05 47.8" },
    },
    [
      _c("defs"),
      _c("title", [_vm._v("overview_icon_1")]),
      _c("g", { attrs: { id: "Layer_2", "data-name": "Layer 2" } }, [
        _c("g", { attrs: { id: "Layer_1-2", "data-name": "Layer 1" } }, [
          _c("polygon", {
            staticClass: "cls-1",
            attrs: {
              points:
                "27.75 21.19 18.48 6.18 4.78 6.18 27.75 42.92 50.89 6.18 36.13 6.18 27.75 21.19",
            },
          }),
          _c("path", {
            staticClass: "cls-2",
            attrs: {
              d: "M33.08,0,27.44,9.76,21.84,0H0L27.43,47.8,55,0ZM27.43,15.77,34.81,3h4.6l-12,20.72L15.55,3h4.55ZM5.18,3h6.91L27.43,29.73,42.88,3h7L27.44,41.78Z",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }